"use client";

import { Phone, Mail, MapPin, Crown, ShieldCheck, Lock, Award, Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

const columns = [
  {
    title: "5 Mondes",
    links: ["Monde Mobile Luxe", "Monde TV & AV Premium", "Monde Électroménager", "Monde Objets Connectés", "Monde Cloud & Data"],
    href: "#mondes",
  },
  {
    title: "7 Merveilles",
    links: ["La Perle Mobile", "L'Oasis Visuelle", "Le Sanctuaire Sonore", "Le Zénith Gaming", "Le Bracelet d'Or", "Le Palais Intelligent", "Le Crystal Data"],
    href: "#merveilles",
  },
  {
    title: "Présidentiel 👑",
    links: ["Smartphone Teranga Gold", "MicroLED Palais 110\"", "Montre d'État Savoir-Faire", "Bureau du Sommet", "Table du Conseil Suprême", "Bastion Présidentiel", "Villa Présidentielle", "Sanctuaire Audio d'État"],
    href: "#presidentiel",
  },
  {
    title: "Solutions Pro",
    links: ["IA Générative", "Cloud Hybride", "Cybersécurité 360", "Fintech & Mobile Money", "IoT Smart City", "Data Analytics & BI"],
    href: "#solutions-pro",
  },
  {
    title: "Services VIP",
    links: ["Livraison Concierge", "Garantie Platinium 3 Ans", "Paiement 6x sans frais", "Concierge 24/7", "Programme Fidélité Or", "Carte Cadeau Luxury"],
    href: "#excellence",
  },
];

const certifications = [
  { icon: Lock, label: "SSL 256-bit" },
  { icon: ShieldCheck, label: "PCI DSS Level 1" },
  { icon: Award, label: ".sn Certified" },
  { icon: Phone, label: "ISO 27001" },
];

export function Footer() {
  return (
    <footer className="mt-auto bg-[#04140D] text-white relative overflow-hidden">
      <div className="absolute top-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#006B3F] via-[#FFD700] to-[#CE1126]" />
      <div className="absolute bottom-0 left-0 right-0 h-[3px] bg-gradient-to-r from-[#CE1126] via-[#FFD700] to-[#006B3F]" />
      <div
        className="absolute inset-0 opacity-30"
        style={{
          background:
            "radial-gradient(ellipse 50% 40% at 85% 0%, rgba(255,215,0,0.08), transparent), radial-gradient(ellipse 40% 40% at 10% 100%, rgba(0,107,63,0.25), transparent)",
        }}
      />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 pt-14 pb-8">
        {/* Top */}
        <div className="grid lg:grid-cols-[1.4fr_3fr] gap-10 pb-10 border-b border-white/10">
          <div>
            <a href="#" className="flex items-center gap-3">
              <div className="w-12 h-12 bg-gradient-to-br from-[#006B3F] to-[#008751] rounded-2xl flex items-center justify-center border border-[#FFD700]/30 shadow-xl">
                <Phone className="w-6 h-6 text-white" />
              </div>
              <div className="leading-tight">
                <p className="font-black text-lg">
                  ★ SENEGAL TELECOM <span className="text-[#00B86B]">STORE</span>
                </p>
                <p className="text-[10px] font-black tracking-[0.35em] bg-gradient-to-r from-[#FFD700] to-[#FFA500] bg-clip-text text-transparent">
                  TERANGA · LUXE
                </p>
              </div>
            </a>
            <p className="text-white/50 text-sm mt-4 leading-relaxed max-w-sm">
              L&apos;excellence technologique au Sénégal. 5 Mondes, 7 Merveilles, Collection
              Présidentielle 👑, Collection Platinum et Solutions Pro Innovantes.
            </p>
            <div className="mt-5 space-y-2 text-sm text-white/70">
              <p className="flex items-center gap-2.5">
                <Phone className="w-4 h-4 text-[#FFD700]" /> +221 33 800 00 00
              </p>
              <p className="flex items-center gap-2.5">
                <Mail className="w-4 h-4 text-[#FFD700]" /> concierge@senegal-telecom.com
              </p>
              <p className="flex items-center gap-2.5">
                <MapPin className="w-4 h-4 text-[#FFD700]" /> SMARTEST CAPITAL, Dakar
              </p>
            </div>
            <div className="mt-5 flex gap-2">
              {[Facebook, Instagram, Twitter, Youtube].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-9 h-9 rounded-xl bg-white/[0.06] border border-white/10 flex items-center justify-center hover:border-[#FFD700]/50 hover:bg-[#FFD700]/10 transition-colors"
                  aria-label="Réseau social"
                >
                  <Icon className="w-4 h-4 text-white/70" />
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6">
            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="font-black text-sm text-[#FFD700] tracking-wide">{col.title}</h4>
                <ul className="mt-3 space-y-2">
                  {col.links.map((link) => (
                    <li key={link}>
                      <a
                        href={col.href}
                        className="text-xs text-white/50 hover:text-[#FFD700] transition-colors leading-snug"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Newsletter */}
        <div className="py-8 border-b border-white/10">
          <div className="flex flex-col lg:flex-row lg:items-center gap-4 justify-between">
            <div className="flex items-center gap-3">
              <Crown className="w-6 h-6 text-[#FFD700]" />
              <p className="font-bold text-white">
                Recevez les avant-premières de la Collection Présidentielle
              </p>
            </div>
            <form
              className="flex gap-2 w-full lg:w-auto"
              onSubmit={(e) => e.preventDefault()}
            >
              <Input
                type="email"
                placeholder="Votre email"
                className="bg-white/10 border-white/20 text-white placeholder:text-white/40 focus-visible:ring-[#FFD700] lg:w-72"
              />
              <Button
                type="submit"
                className="bg-gradient-to-r from-[#FFD700] to-[#FFA500] text-black font-bold shrink-0"
              >
                S&apos;inscrire
              </Button>
            </form>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-white/40">
            © 2026 ★ SENEGAL TELECOM STORE · Teranga — Tous droits réservés
          </p>
          <div className="flex flex-wrap justify-center gap-2">
            {certifications.map((c) => (
              <span
                key={c.label}
                className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/[0.05] border border-white/10 text-[10px] font-semibold text-white/60"
              >
                <c.icon className="w-3 h-3 text-[#FFD700]" /> {c.label}
              </span>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
